import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";
import { ICreateAppVersion } from "models/appVersion";
import createAppVersionValidator from "validators/createAppVersion.validator";
import { createAppVersionsApi } from "api/appVersion";

export default function useCreateAppVersion() {
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<ICreateAppVersion>({
    resolver: yupResolver(createAppVersionValidator),
  });

  const onSubmit = async (input: ICreateAppVersion) => {
    setLoading(true);
    const { data, error } = await createAppVersionsApi(input);
    if (data) {
      showSuccess("App version created Successfully");
      navigate(RouteName.APP_VERSION, { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading(false);
  };

  return { handleSubmit, onSubmit, control, loading };
}
